import {
    BoltDiameter,
    BoltType,
    SensorFrequency,
    SensorSize,
    Material,
    MeasurementType,
} from '../_generated/api/tagged-hardware'
import { _tf } from './t'

// This option helps consolidate all the identical option types used in Primereact.
// Instead of arbitrarily choosing one of those models that include extra, unnecessary data fields,
//  we specify this minimal model that satisfies all option model constraints without extraneous data.
export interface BasicOption {
    label: string
    value: string
}

/*
 * Parse values of the type only, as the left hand side is cased inappropriately,
 *  and does not correspond to enum values.
 */
export const generateOptions = <T>(
    mapping: Record<string, string>,
    allowNone: boolean,
    mapper: (value: string) => T
): T[] =>
    Object.values(mapping)
        .filter((value) => allowNone || value !== 'none')
        .map(mapper)

export const generateTypeOptions = (
    type: Record<string, string>,
    model: string,
    field: string,
    allowNone: boolean = true
): BasicOption[] =>
    generateOptions(type, allowNone, (value: string) => ({
        label: _tf(model, field, value),
        value,
    }))

/**
 * Sort diameter options, because they are numeric (prefixed with M),
 *  but are not guaranteed to be in correct order when received from the API.
 */
export const BoltDiameterSettings = (() => {
    const options = generateTypeOptions(BoltDiameter, 'bolt', 'diameter', false)
    const toInt = (diameter: string) => parseInt(diameter.toLowerCase().replace('m', ''))
    options.sort((a, b) => toInt(a.value) - toInt(b.value))
    return options
})()

export const BoltTypeSettings = generateTypeOptions(BoltType, 'bolt', 'type', false)
export const SensorFrequencySettings = generateTypeOptions(
    SensorFrequency,
    'sensor',
    'frequency',
    false
)
export const SensorSizeSettings = generateTypeOptions(SensorSize, 'sensor', 'size', false)
export const MaterialSettings = generateTypeOptions(Material, '', 'material', false)
export const MeasurementTypeSettings = generateTypeOptions(
    MeasurementType,
    'measurement',
    'type',
    false
)
